import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Dealer, DEALERS, DealerCurrent, DealerStatus, DEALER_STATUSES} from '../data/dealer';
import { FuncsService } from '../services/funcs.service';
import { Router } from '@angular/router';
import { DealerService } from '../services/dealer.service';
import { FordService } from '../services/ford.service';
// import {Subscription} from 'rxjs';
import {Subscription} from '../data/subscription';

@Component({
    selector: 'app-report-enrolled',
    templateUrl: './report-enrolled.component.html',
    styleUrls: ['./report-enrolled.component.css'],
    standalone: false
})

export class ReportEnrolledComponent {
  public loading = "Loading...";
  dealers = DEALER_STATUSES;
  displayedDealers = this.dealers;
  search = "";
  country = "USA";
  enrolled = "E";
  queryEnrolled: string = "";
  countries: string[] = ["USA"];
  dealersNotInAPI: string[] = [];

  constructor(
    private dealerService: DealerService,
    private router: Router,
    private route: ActivatedRoute,
    private fordService: FordService,
    private funcs: FuncsService
  ) {}

  ngOnInit(): void {
    this.funcs.checkAdmin();
    this.loading = "Loading...";

    this.queryEnrolled = this.route.snapshot.queryParamMap.get('enrolled') || '';
    if (["E", "U", "A"].indexOf(this.queryEnrolled) > -1) {
      this.enrolled = this.queryEnrolled;
    }

    /*this.dealerService.getDealers().subscribe(dealers => {
      // this.dealers = dealers;
      this.loading = "";
      this.displayDealers();
      // this.getAllDealerStatus();
    });*/
    this.getAllDealerStatus();
  }

  ngAfterViewInit(): void {
    document.getElementById("admin-dealer")?.focus();
  }

  changeRadio(eventEnroll: Event) {
    this.enrolled = (eventEnroll.target as HTMLInputElement).value;
    this.displayDealers();
  }

  getAllDealerStatus(): void {
    /*
    OK, so what we want to do here is
      1. Get all dealers from our system. (From the dealer tables or from the subscriptions log?)
      2. Get all subscriptions from the API - simultaneous with forkJoin?
      3. Reconcile them
        a. Update current dealers with new information
        b. add new dealers to the subscription table
        c. If status has a dealer not in API, set expiresAt to the past
        d. store all in this.dealers (can happen while b is happening in parallel)
      4. Filter according to dealer search box and country

    We also need to have a list of countries based on the user: all for Admin or a selection for 
    region managers.

    OK, so I need:
    1. admin-dealer page with this logic
    2. techs # displayed
    3. enrolled logic
    4. enroll/cancel using start and expires dates
    5. unsubscribe missing dealers from API - add removed column from status table
    6. white list front end at server
    7. Add this logic to individual dealer data page
    */

    function hasCountry(siteCode: string) {
      if (siteCode.length < 4) {
        return false;
      }
      var reCountryPrefix = /^[A-z]{3}/i;
      if (!reCountryPrefix.test(siteCode)) {
        return false;
      }
      return true;
    }

    const dealerStatusData = this.dealerService.getStatus();
    const subscriptionData = this.fordService.getAllSubscriptions();

    forkJoin([dealerStatusData, subscriptionData]).subscribe(responses => {
      this.dealers = responses[0].filter(s => hasCountry(s.pa_code));
      var subscriptions = responses[1].filter(s => hasCountry(s.siteCode));

      this.loading = "";

      subscriptions.forEach(s => {
        var country3 = this.funcs.getThreeLetterCountry(s.siteCode);

        if (country3 && this.countries.indexOf(country3) === -1) {
          this.countries.push(country3);
        }
        if (!s.startDate) {
          s.startDate = (new Date(0)).toISOString();
        }
        if (!s.expiresAt) {
          s.expiresAt = (new Date(0)).toISOString();
        }
        if (!s.concurrentSessions) {
          s.concurrentSessions = 0;
        }
        if (!s.maxAllowedUniqueDealerTechnicianLogins) {
          s.maxAllowedUniqueDealerTechnicianLogins = 0;
        }
        // dealersFound.push(s.siteCode);
        // check for new subscriptions from service
        if (!this.dealers.some(d => s.siteCode === d.pa_code)) {
          this.fordService.logSubscription(s).subscribe(t => {
            console.log(t);
          });
          return;
        }

        var changed = false;
        var subscribeDealer :DealerStatus = <DealerStatus>{};
        subscribeDealer = this.dealers.find(d => d.pa_code === s.siteCode) || <DealerStatus>{};
        var iDealer = this.dealers.findIndex(d => d.pa_code === s.siteCode);

        if (subscribeDealer.startDate) {
          subscribeDealer.startDate = subscribeDealer.startDate + "Z";
        }
        if (subscribeDealer.expiresAt) {
          subscribeDealer.expiresAt = subscribeDealer.expiresAt + "Z";
        }
        var dealerTest = JSON.parse(JSON.stringify(subscribeDealer));
        if (Math.abs(+(new Date(subscribeDealer.startDate)) - Math.abs(+(new Date(s.startDate)))) > 1000) {
          subscribeDealer.startDate = s.startDate;
          changed = true;
        }
        if (subscribeDealer.tech_count != s.maxAllowedUniqueDealerTechnicianLogins) {
          subscribeDealer.tech_count = s.maxAllowedUniqueDealerTechnicianLogins;
          changed = true;
        }
        if (subscribeDealer.concurrent_sessions !== s.concurrentSessions) {
          subscribeDealer.concurrent_sessions = s.concurrentSessions;
          changed = true;
        }
        if (Math.abs(+(new Date(subscribeDealer.expiresAt)) - +(new Date(s.expiresAt))) > 1000) {
          subscribeDealer.expiresAt = s.expiresAt;
          changed = true;
        }

        if (changed) {
          if (!s.startDate) {
            s.startDate = (new Date()).toISOString();
          }

          // Update dealer list
          this.dealers[iDealer].startDate = subscribeDealer.startDate;
          this.dealers[iDealer].tech_count = subscribeDealer.tech_count;
          this.dealers[iDealer].concurrent_sessions = subscribeDealer.concurrent_sessions;
          this.dealers[iDealer].expiresAt = subscribeDealer.expiresAt;

          var newSub: Subscription = <Subscription>{};
          newSub.createdAt = s.createdAt;
          newSub.startDate = subscribeDealer.startDate;
          newSub.siteCode = subscribeDealer.pa_code;
          newSub.maxAllowedUniqueDealerTechnicianLogins = subscribeDealer.tech_count;
          newSub.concurrentSessions = subscribeDealer.concurrent_sessions;
          newSub.expiresAt = subscribeDealer.expiresAt;
          newSub.status = 200;

          this.fordService.logSubscription(newSub).subscribe(t => {
            console.log(t);
          });
        }

        // set subscribed
        this.dealers[iDealer].subscribed = (this.funcs.isSubscribed(s)) ? "Y" : "- -";
      });

      // remove and dealers not in the list
      // no, just hide them. No reason to do any deleting
      this.dealersNotInAPI.length = 0;
      this.dealers.forEach(d => {
        if (subscriptions.findIndex(s => s.siteCode === d.pa_code) === -1) {
          // mark as removed from status table
          this.dealersNotInAPI.push(d.pa_code);
        }
      });
      // wait, what if the removed dealers pop back up? Just unremove them?

      this.countries = this.countries.sort();
      this.displayDealers();
    });
  }

  getSingleDealerStatus(pa_code: string): void {
    this.fordService.getSubscription(pa_code).subscribe(sub => {
      var dealer = this.displayedDealers.find(d => {
        return d.pa_code == pa_code;
      }) || <Dealer>{};
      dealer.subscribed = (sub.status == 404) ? " - " : "Yes";
      // this.sub = sub;
      // this.prices = this.funcs.priceByTier(this.dealer.tech_count, this.dealer.country3);

      // this.loading = false;
      // this.enrolled = new Date(this.sub.createdAt).toDateString();
      // var enrollCell: HTMLTableCellElement = document.querySelector('th[data-pa="d.pa_code"]') || <HTMLTableCellElement>{};
      // enrollCell.textContent = (sub.status == 404) ? " - " : "Yes";
      // this.getAllDealerStatus();
    });
  }

  displayDealers() {
    this.displayedDealers = this.dealers.filter(this.isDealer);
  }

  private isDealer = (d: DealerStatus) => {
    var ciSearch = this.search.toLowerCase();
    var ciName = d.name.toLowerCase();
    var ciCountry = this.country;
    if (this.dealersNotInAPI.indexOf(d.pa_code) > -1) {
      return false;
    }
    // Should a blank country be USA by default or just clean up the test data?
    return (d.pa_code.indexOf(ciSearch) > -1 || ciName.indexOf(ciSearch) > -1) && this.isEnrolled(d) && d.country === ciCountry;
  };

  private isEnrolled = (d: DealerStatus) => {
    return true;
    /*if (this.enrolled === "E" && d.subscribed === "Y") {
      return true;
    }
    if (this.enrolled === "U" && d.subscribed === "N") {
      return true;
    }
    if (this.enrolled === "A") {
      return true;
    }
    return false;*/
  };

  fly(d: DealerStatus) {
    DealerCurrent.pa_code = d.pa_code;
    DealerCurrent.name = d.name;
    DealerCurrent.tech_count = d.tech_count;
    DealerCurrent.subscribed = d.subscribed;
    DealerCurrent.active = "";

    // persist data
    var dealerStore = {
      pa_code: DealerCurrent.pa_code,
      name: DealerCurrent.name,
      tech_count: DealerCurrent.tech_count,
      subscribed: DealerCurrent.subscribed,
      active: DealerCurrent.active
    };
    window.localStorage.setItem("dealer", JSON.stringify(dealerStore));
    this.router.navigateByUrl('/status-enrolled');
  };

  /*download() {
    var csv = ["PA Code,Name,Country,Techs"];
    this.dealers.filter(this.isDealer).forEach(d => {
      csv.push(`"${d.pa_code}","${d.name}","${d.country}",${d.tech_count}`);
    });
    var data = new Blob([csv.join("\n")]);
    var a: HTMLAnchorElement = document.createElement("a");
    a.download = "dealer.csv";
    a.href = URL.createObjectURL(data);
    a.click();
  }*/

  getEnrollStatus(): string{
    // get status for pa_code and update
    return "Yes";
  }
}
